import React, { useState, useEffect } from "react";

import { Stack } from "@chakra-ui/react";

import { useParams } from "react-router-dom";

import PageDetailHeader from "components/PageDetailHeader/PageDetailHeader";

import useDocumentTitle from "hooks/useDocumentTitle";

import CustomRequestDetailBreadcrumbConstant from "constants/BreadCrumbConstants/CustomRequestDetailBreadcrumbConstant";

import {
  Accordion,
  Spinner,
  Button,
  useDisclosure,
  Select,
} from "@chakra-ui/react";
import FilesTabAccordionItem from "components/FilesTabAccordionItem/FilesTabAccordionItem";

import summary_blue_icon from "../assets/images/icons/summary_icon/summary_blue_icon.png";
import SummaryDrawer from "components/SummaryDrawer/SummaryDrawer";

import data_not_found_blue_icon from "../assets/images/icons/general_icons/data_not_found_blue_icon.png";
import GetCustomRequestFiles from "services/GetCustomRequestFiles";
import { getPdfHeadings } from "components/pdf/pdfUtils";

export default function CustomRequestDetail() {
  useDocumentTitle("Custom Request Detail");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { request_id, supplier_name } = useParams();

  const [supplierChangesDetails, setSupplierChangesDetails] = useState([]);
  const [supplierChangesSummary, setSupplierChangesSummary] = useState("");
  const [loadingFiles, setLoadingFiles] = useState(true);

  useEffect(() => {
    const params = {
      request_id: request_id,
    };

    const callGetSupplierChanges = async () => {
      setLoadingFiles(true);

      try {
        const resp = await GetCustomRequestFiles({
          supplier_request_id: request_id,
        });
        setSupplierChangesDetails(resp?.data.data);
        setSupplierChangesSummary(resp?.data?.data?.supplier_changes_summary);
      } catch (error) {
        console.log("Error in fetching supplier changes", error);
      } finally {
        setLoadingFiles(false);
      }
    };

    callGetSupplierChanges();
  }, []);

  console.log(
    "supplierChangesDetails",
    supplierChangesDetails,
    supplierChangesDetails.length
  );

  return (
    <div className="">
      <SummaryDrawer
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        summaryText={supplierChangesSummary}
      />
      <Stack spacing={"2rem"}>
        <PageDetailHeader
          breadCrumbList={CustomRequestDetailBreadcrumbConstant}
          heading={supplier_name}
        />

        <div>
          {!loadingFiles &&
            supplierChangesDetails?.supplier_changes_files_name?.length > 0 && (
              <Button variant="ghost" onClick={onOpen}>
                <div className="flex flex-row gap-2 ">
                  <div className="h-[20px] w-[20px] ">
                    <img className="" src={summary_blue_icon} />
                  </div>
                  <p className="hidden secondary-text sm:block ">
                    View Summary
                  </p>
                </div>
              </Button>
            )}
          {loadingFiles ? (
            <div className="w-full h-[30vw]  flex flex-row justify-center">
              <div className="my-auto">
                <Spinner size="lg" />
              </div>
            </div>
          ) : supplierChangesDetails?.supplier_changes_files_name?.length ===
            0 ? (
            <div className="w-full h-[30vw]  flex flex-row justify-center">
              <div className="flex flex-row justify-center gap-2 my-auto ">
                <img src={data_not_found_blue_icon} />
                <p>No data found!</p>
              </div>
            </div>
          ) : (
            <Accordion variant="custom" allowMultiple defaultIndex={[2]}>
              {supplierChangesDetails?.supplier_changes_files_name?.map(
                (data, index) => {
                  return (
                    <FilesTabAccordionItem
                      file_name={data}
                      file_changes_data={
                        supplierChangesDetails?.supplier_changes_files_data[
                          index
                        ]
                      }
                    />
                  );
                }
              )}
            </Accordion>
          )}
        </div>
      </Stack>
    </div>
  );
}
